import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

import { useDisclosure } from "@mantine/hooks";
import classes from "../../css/Header.module.css";
import {
  UserContext,
  UserContextType,
} from "@/contexts/UserContext/UserContext";
import { Text } from "../Generics/Text";
import { Btn } from "../Generics/Btn";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";

export const Header: React.FC = () => {
  const context = useContext(UserContext) as UserContextType;
  const navigate = useNavigate();
  const { colors, isDarkMode } = useAppColors();

  const handleLogout = () => {
    context.logout();
    navigate("/signin");
  };
  const handleNavigateHome = () => {
    navigate("/");
  };

  return (
    <div
      className={classes.header}
      style={{ backgroundColor: isDarkMode ? colors.brand : colors.gray }}
    >
      <div className={classes.leftBox} onClick={handleNavigateHome}>
        <div className={classes.headbox}>
          <img
            src={require("../../assets/shiplify-logo.png")}
            alt="Logo"
            className={classes.logo}
          />
        </div>
        <div className={classes.productName} style={{ color: "goldenrod" }}>
          Pro
        </div>
      </div>

      <div className={classes.headContainer}>
        {context.user ? (
          <div
            onClick={handleLogout}
            className={classes.btn}
            style={{
              backgroundColor: isDarkMode ? colors.secondary : colors.brand,
            }}
          >
            {/*
            <Text color={colors.primary}>Logout</Text>
            */}
            <LogOut color={colors.primary} />
          </div>
        ) : (
          <Btn action={() => navigate("/signin")}>
            <Text color={colors.primary}>Sign In</Text>
          </Btn>
        )}
        {/* <LightDarkButton /> */}
        {/*
        <DarkModeBtn />
        */}
        {/*
        <VersionDisplay version="Beta" />
        */}
      </div>
      {/*
        <Burger opened={drawerOpened} onClick={toggleDrawer} hiddenFrom="sm" />
        */}
      {/*
      <ScrollArea h={`calc(100vh - ${rem(80)})`} mx="-md">
        <Divider my="sm" />
        <Link to="/" className={classes.link} onClick={closeDrawer}>
          Home
        </Link>
        <Divider my="sm" />
        <Group justify="center" grow pb="xl" px="md">
          {context.user ? (
            <Button
              variant="default"
              onClick={() => {
                handleLogout();
                closeDrawer();
              }}
            >
              Logout
            </Button>
          ) : (
            <Button
              component={Link}
              to="/signin"
              variant="default"
              onClick={closeDrawer}
            >
              Sign In
            </Button>
          )}
        </Group>
      </ScrollArea>
      */}
    </div>
  );
};
